import MobileLayout from '../../layouts/MobileLayout';
import InitContent from '../shared/InitContent';

export default function MobileAuthPage() {
  return (
    <MobileLayout>
      <InitContent />
    </MobileLayout>
  );
}
